import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { amplifyInit } from "@/lib/aws-amplify"; // Amplifyの初期化
import { captureUtmOnLoad } from "@/lib/hubspot";
import { zodI18nInit } from "@/lib/zod/zod-i18n-init";

import { MaintenanceGate } from "@/components/maintenance/maintenance-gate";
import { ApolloClientProvider, AuthProvider, NewRelicProvider, ReactHelmetAsyncProvider } from "@/providers";
import { RouterProvider } from "@/routes";

import "@/styles/globals.css";

// 各種ライブラリの初期化
amplifyInit(); // Amplifyの初期化
zodI18nInit(); // Zodの初期化
captureUtmOnLoad(); // UTM パラメータを保存（HubSpot 流入経路トラッキング用）

const rootElement = document.getElementById("root")!;
ReactDOM.createRoot(rootElement).render(
	<React.StrictMode>
		<AuthProvider>
			<NewRelicProvider>
				<ApolloClientProvider>
					<ReactHelmetAsyncProvider>
						<MaintenanceGate>
							<RouterProvider />
						</MaintenanceGate>
					</ReactHelmetAsyncProvider>
				</ApolloClientProvider>
			</NewRelicProvider>
		</AuthProvider>
	</React.StrictMode>,
);
